import $ from "jquery";
import axios from "axios";

export default function SVGCustomButtons() {
    const orangeColor = "#ef792f";
    const link = localStorage.getItem("link");
  
    let elementNamesWithSVGButtons = [];
    let svgButtonsWhichCanHaveState = [];
    let prjElements_Info = {};

    function loadCustomButtons() {
        let buttons = document.querySelectorAll("g[data-buttontype=\"stateControllerCommands\"]")
        console.debug("loadCustomButtons() Buttons: %o", buttons);

        buttons.forEach((item) => {
            console.debug("CustomButton %o", item);

            initSVGCustomButton_StateControllerCommands(item);

            item.setAttribute('data-isActive', '0');
            item.setAttribute('cursor', 'pointer');
            $(item).hover(function (event) {
                this.children[0].setAttribute('fill', orangeColor);
            }, function () {
                let color = this.getAttribute('data-isActive') === '0' ? 'white' : orangeColor;
                this.children[0].setAttribute('fill', color);
            });
        });
        console.debug("loadCustomButtons() finished: elementNamesWithSVGButtons: %o", elementNamesWithSVGButtons);
    }

    function initSVGCustomButton_StateControllerCommands(button) {
        try {
            const commands = button.getAttribute("data-commands");
            const commandsJson = JSON.parse(commands);
            const elementNames = [];
            let buttonCanShowState = false;
            let allCommandsTheSame = true;
            let command = '';

            commandsJson.forEach(function (cmd, index, array) {
                elementNames.push(cmd.Name);
                if (command === '') {
                    command = cmd.Command;
                }
                if (command !== cmd.Command) {
                    allCommandsTheSame = false;
                }
                if (cmd.Command === "SwitchElementMode") {
                    buttonCanShowState = true;
                }
            });

            if (buttonCanShowState && allCommandsTheSame) {
                const buttonInfo = {
                    Button: button,
                    Command: command,
                    CommandJSON: commandsJson,
                    ElementNames: elementNames,
                };

                svgButtonsWhichCanHaveState.push(buttonInfo);
                elementNames.forEach(function (elementName, index, array) {
                    if (!elementNamesWithSVGButtons.includes(elementName)) {
                        elementNamesWithSVGButtons.push(elementName);
                    };
                });
            }

            console.debug("Added StateControllerCommand Button %o", button);
            $(button).click(function () { stateControllerButtonClicked(this.getAttribute("data-commands"), this); });
        } catch (e) {
            console.error("Error while initSVGCustomButton_StateControllerCommands %o", e);
        }

        // {"Command": "SwitchElementMode", "Name": "RT01", "Mode": "ManualClose"}
    }

    function stateControllerButtonClicked(commands, sender) {
        try {
            console.debug("stateControllerButtonClicked: Commands: %s; Button %o", commands, sender);
            let url = link + '/api/LayoutFiles/StateControllerButtonClick';

            axios.post(url, commands, { headers: { "Content-Type": "text/plain" } })   // Da wir commands per string übergeben wollen, muss der Content-Type angepasst werden.
                .catch(function (error) {
                    console.error("Error while sending Button Click to Backend", error);
                })
                ;

            giveSVGCustomButtonConfirmation(sender, false);
        } catch (e) {
            console.error("Error while stateControllerButtonClicked %o", e)
            giveSVGCustomButtonConfirmation(sender, true);
        }
    }

    function giveSVGCustomButtonConfirmation(sender, error) {
        const element = sender.children[0];
        const color = error ? 'red' : 'green';

        // Hier wurde früher mit new Snap(element); eine Transition beim Farbwechsel gemacht. Keine Ahnung, wo die Lib her kam, erst mal unwichtig.
        element.setAttribute('fill', color);

        setTimeout(function () {
            const colorNew = element.getAttribute('data-isActive') === '0' ? 'white' : orangeColor;
            element.setAttribute('fill', colorNew);
        }, 200);
    }

    function svgElementsLoaded(mapdata) {
        mapdata.forEach(function (d) {
            prjElements_Info[d.name] = d;
        });
    }

    function elementChangeReceived(data) {
        const elementName = data.name;
        prjElements_Info[elementName] = data;

        const anyButtonWithThatElement = elementNamesWithSVGButtons.includes(elementName);
        // console.debug("elementChangeReceived: %s; AnyButtonWithThat? %o; %o", elementName, anyButtonWithThatElement, data);

        if (anyButtonWithThatElement) {
            checkSVGButtonsAndSetState();
        }
    }

    function checkSVGButtonsAndSetState(data) {
        console.log("checkSVGButtonsAndSetState called");
        try {
            console.groupCollapsed("checkSVGButtonsAndSetState");

            svgButtonsWhichCanHaveState.forEach(function (buttonInfo) {
                console.debug("checkSVGButtonsAndSetState: processing Button: %o", buttonInfo);

                switch (buttonInfo.Command) {
                    case "SwitchElementMode":
                        let allModesAsTheyShouldBe = true;

                        buttonInfo.CommandJSON.forEach(function (jsonCommand) {
                            const elementInfo = prjElements_Info[jsonCommand.Name];
                            console.debug("checkSVGButtonsAndSetState: processing Button: %o; JsonCommand: %o; Element_Info: %o", buttonInfo, jsonCommand, elementInfo);
                            if (!elementInfo) {
                                allModesAsTheyShouldBe = false;
                            } else {
                                const modeToBe = jsonCommand.Mode;
                                const elementMode = elementInfo.mode;
                                if (elementMode !== modeToBe) {
                                    allModesAsTheyShouldBe = false;
                                }
                            }
                        });

                        console.debug("checkSVGButtonsAndSetState: processing Button: %o => allModesAsTheyShouldBe? %o", buttonInfo, allModesAsTheyShouldBe);

                        buttonInfo.Button.setAttribute('data-isActive', allModesAsTheyShouldBe ? '1' : '0');
                        if (allModesAsTheyShouldBe) {
                            buttonInfo.Button.children[0].setAttribute('fill', orangeColor);
                        } else {
                            buttonInfo.Button.children[0].setAttribute('fill', 'white');
                        }

                        break;
                }
            });

            console.groupEnd();
        } catch (e) {
            console.error("Error while checkSVGButtonsAndSetState", e);
        }
    }

    return {
        loadCustomButtons, checkSVGButtonsAndSetState, svgElementsLoaded, elementChangeReceived
    };
}